const TextInput = ({
  className,
  icon,
  action,
  handleAction,
  variant = 'solid',
  style,  // Accept the style prop
  ...props
}) => {
  let inputClassNames = ''

  switch (variant) {
    case 'solid':
      inputClassNames = `flex-1 bg-transparent text-black rounded-[10px] transition duration-200 ease-in-out py-2 px-2 pr-2`
      break
  }

  return (
    <div
      className={`flex shadow items-center border border-gray-100 rounded-[10px] bg-white ${className}`}
    >
      {icon && (
        <span className="text-[#ffb800] text-[1.7rem] pl-3">{icon}</span>
      )}
      <input
        className={inputClassNames}
        {...props}
        style={{
          outline: 'none',
          ...style,  // Spread the style prop to apply dynamic styles
        }}
      />
      {action && (
        <span
          className="cursor-pointer text-[#ffb800] text-[1.2rem] pr-3"
          onClick={handleAction}
        >
          {action}
        </span>
      )}
    </div>
  )
}

export default TextInput
